export const noopEvent = e => e && e.preventDefault();
export const noop = () => {};

export const blobToFile = (blob, fileName) => {
  blob.lastModifiedDate = new Date();
  blob.name = fileName;
  return blob;
};



// WEBPACK FOOTER //
// ./app/javascript/common/utils/helpers.js